<template>
    <div class="row">
        <div class="col-md-12">
            <section class="panel">
                <header class="panel-heading">
                    <h2 class="panel-title">資料輸出</h2>
                </header>
                <div class="panel-body container-fluid">
                    <div class="form-inline">
                        <div class="row form-group">
                            <div class="col-md-12 form-group">
                                <label for="id" class="column-required">報 表 : </label>
                                <select id="id" name="id" v-validate="'required'" v-model="exportForm.id" class="form-control" :style="{width:'auto', display:'inline-block'}">
                                    <option value="">請選擇</option>
                                    <option value="1">身障類</option>
                                    <option value="2">其餘類別</option>
                                </select>
                            </div>
                        </div>
                        <div class="btn-group">
                            <button @click="handleExport" class="btn s_btn_b">匯出</button>
                        </div>
                    </div>
                </div>
            </section>
            <section class="panel">
                <header class="panel-heading">
                    <h2 class="panel-title">資料匯入</h2>
                </header>
                <div class="panel-body container-fluid">
                    <div class="row form-group">
                        <div class="col-md-12 form-group">
                          <label for="smtr" class="column-required">作業學期 : </label>
                          <input type="text" class="form-control" ref="smtr" name="smtr" id="smtr" :style="{width:'auto', display:'inline-block'}"/>
                          <span>(例109年第一學期 即輸入1091)</span>
                        </div>
                        <div class="col-md-12 form-group">
                            <label for="disability" >身障類查核結果:</label>
                            <input type="file" ref="disabilityFile" name="disability" id="disability" :style="{width:'auto', display:'inline-block'}"/>

                        </div>
                        <div class="col-md-12 form-group">
                            <label for="repeat" >重複請領比對結果:</label>
                            <input type="file" ref="repeatFile" name="repeat" id="repeat" :style="{width:'auto', display:'inline-block'}"/>
                        </div>
                    </div>
                    <div class="btn-group">
                        <button @click="handleUpload" class="btn s_btn_b">上傳</button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    data() {
		return {
            exportForm: {
                id: ""
            }
		}
	},
	methods: {
		handleExport() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const api = `/api/relief/export/report/${this.exportForm.id}`;

                    this.$axios.get(api, {
                        responseType: 'blob'
                    }).then(resp => {
                        const url = window.URL.createObjectURL(new Blob([resp.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `檔案輸出${this.exportForm.id == 1 ? "身障類" : "其他類"}_${this.customFormatter(new Date(),"YYYYMMDD")}.csv`);
                        document.body.appendChild(link);
                        link.click();
                    });
				} else {
					bootbox.alert("請選擇匯出的報表")
				}
			});
		},
        handleUpload() {
            const disabilityFile = this.$refs.disabilityFile.files[0];
            const repeatFile = this.$refs.repeatFile.files[0];
            if (!disabilityFile && !repeatFile) {
				bootbox.alert("未上傳任何檔案");
                return;
            }

            if(this.$refs.smtr.value == ""){
                bootbox.alert("請輸入學期");
                return;
            }

			const api = "/api/relief/import/report";

			let formData = new FormData();
            formData.append('disabilityFile', disabilityFile);
            formData.append('repeatFile', repeatFile);
            formData.append('smtr', this.$refs.smtr.value);


            this.$axios.post(api, formData).then(resp => {
                if(resp.data.status == "success") {
                    bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
                } else {
                    bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
                }
                this.$refs.disabilityFile.value = null;
                this.$refs.repeatFile.value = null;
            });
		}
	}
}
</script>

<style scoped>
</style>
